module.exports = __webpack_public_path__ + "media/images/mobile/home/search_ban-a6b6d36e5b2657721e3935cb5bdd8e00.png";